import React from "react";
import { Box, VStack, Circle } from "@chakra-ui/react";
import { m, AnimatePresence } from "framer-motion";
import { MotionDiv } from "../lazyMotionDom";

/** 親の `shell.isLoading` でマウント／アンマウントされるため、内部で useEffect は不要 */
const Loading = () => {
  return (
    <AnimatePresence>
      <MotionDiv
        initial={{ opacity: 1 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="tg-loading-overlay"
      >
        <VStack spacing={8}>
          <Box position="relative" width="100px" height="40px">
            <MotionDiv
              className="tg-loading-dot-mover"
              animate={{ x: [-30, 30] }}
              transition={{
                duration: 1.5,
                ease: "easeInOut",
                repeat: Infinity,
              }}
            >
              <m.div layout>
                <Circle size="20px" bg="rgb(194, 153, 78)" />
              </m.div>
            </MotionDiv>

            <MotionDiv
              className="tg-loading-dot-mover"
              animate={{ x: [30, -30] }}
              transition={{
                duration: 1.5,
                ease: "easeInOut",
                repeat: Infinity,
              }}
            >
              <m.div layout>
                <Circle size="20px" bg="rgb(160, 148, 62)" />
              </m.div>
            </MotionDiv>
          </Box>
        </VStack>
      </MotionDiv>
    </AnimatePresence>
  );
};

export default Loading;
